module.exports = __webpack_public_path__ + "img/authing.b597203f.png";